import { useCallback } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import { createContainer } from 'unstated-next'
import { CatalogItem } from 'types/model'

interface CatalogItemState {
  catalogItem: CatalogItem
}

export interface CatalogItemContainer extends CatalogItemState {
  initCatalogItem: (state: CatalogItemState) => void
}

const useCatalogItem = () => {
  // This state is always provided at render time
  const [catalogItem, setCatalogItem] = useLocalStorage<CatalogItem>(
    'catalogItem',
    undefined!
  )

  const initCatalogItem = useCallback(
    ({ catalogItem }: CatalogItemState) => setCatalogItem(catalogItem),
    [setCatalogItem]
  )

  return { catalogItem, initCatalogItem }
}

export default createContainer<CatalogItemContainer>(useCatalogItem)
